import React from "react";
import "../styles/ExperienceSection.css";

const experiences = [
  {
    title: "Sunrise Yoga",
    text: "Start your morning with peaceful yoga overlooking the Himalayas.",
    img: "https://images.unsplash.com/photo-1506126613408-eca07ce68773"
  },
  {
    title: "Nature Walks",
    text: "Explore beautiful mountain trails with experienced guides.",
    img: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee"
  },
  {
    title: "Meditation",
    text: "Reconnect with yourself through guided meditation sessions.",
    img: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88"
  },
  {
    title: "Campfire Nights",
    text: "End the day with stories and stargazing around the fire.",
    img: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429"
  }
];

export default function ExperienceSection(){
  return(
    <section className="experience">

      <h2 className="experience-title">Retreat Experiences</h2>

      <div className="experience-grid">

        {experiences.map((exp,i)=>(
          <div className="experience-card" key={i}>

            <img src={exp.img} alt={exp.title}/>

            <div className="experience-content">
              <h3>{exp.title}</h3>
              <p>{exp.text}</p>
            </div>

          </div>
        ))}

      </div>

    </section>
  )
}